import { useLayoutEffect, useState } from "react";
import { getClientInfo } from "@/pages/setup/actions";
import { useAuth } from "@/providers/auth";

const useGetClientInfo = () => {
  const [clientInfo, setClientInfo] = useState({});
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  useLayoutEffect(() => {
    let isMounted = true;

    const getClientInformation = async () => {
      try {
        const res = await getClientInfo(id);
        if (isMounted && res) {
          setClientInfo(res);
        }
      } catch (e) {
        if (isMounted) {
          console.log(e);
        }
      }
    };

    getClientInformation();

    return () => {
      isMounted = false;
    };
  }, [id]);

  return clientInfo;
};

export default useGetClientInfo;
